import React from 'react';

const BetSettings = ({ betBody, setBetBody }) => {
  const updateBetPayload = (field, value) => {
    setBetBody((prev) => ({
      ...prev,
      betPayload: { ...prev.betPayload, [field]: value },
    }));
  };

  const updateSlotSettings = (field, value) => {
    setBetBody((prev) => ({
      ...prev,
      config: {
        ...prev.config,
        slot: {
          ...prev.config.slot,
          settings: {
            ...prev.config.slot.settings,
            bets: {
              ...prev.config.slot.settings.bets,
              [field]: value,
            },
          },
        },
      },
    }));
  };

  const updateLineSetMultiplier = (value) => {
    setBetBody((prev) => ({
      ...prev,
      config: {
        ...prev.config,
        lineSets: prev.config.lineSets.map((lineSet, index) =>
          index === 0 ? { ...lineSet, coin_amount_multiplier: value } : lineSet,
        ),
      },
    }));
  };

  const updateStartPosition = (positionsString) => {
    try {
      const positions = positionsString.split(',').map((val) => parseInt(val.trim()) || 0);
      setBetBody((prev) => ({
        ...prev,
        config: {
          ...prev.config,
          slot: {
            ...prev.config.slot,
            settings: {
              ...prev.config.slot.settings,
              startPosition: positions,
            },
          },
        },
      }));
    } catch (error) {
      console.log('Error parsing positions:', error);
    }
  };

  return (
    <div className="grid grid-cols-1 gap-6 mb-6 xl:grid-cols-2">
      {/* Simulation Settings */}
      <div className="p-4 rounded-lg bg-gray-50">
        <h3 className="mb-3 text-lg font-semibold text-gray-900">Simulation Settings</h3>
        <div className="space-y-3">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Iterations Count</label>
            <input
              type="number"
              value={betBody.iterationsCount}
              onChange={(e) =>
                setBetBody((prev) => ({
                  ...prev,
                  iterationsCount: parseInt(e.target.value) || 1,
                }))
              }
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              min="1"
            />
          </div>
        </div>
      </div>

      {/* Bet Payload */}
      <div className="p-4 rounded-lg bg-gray-50">
        <h3 className="mb-3 text-lg font-semibold text-gray-900">Bet Payload</h3>
        <div className="space-y-3">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Coin Amount</label>
            <input
              type="number"
              value={betBody.betPayload.coinAmount}
              onChange={(e) => updateBetPayload('coinAmount', parseInt(e.target.value) || 0)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              min="1"
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Coin Value</label>
            <input
              type="number"
              value={betBody.betPayload.coinValue}
              onChange={(e) => updateBetPayload('coinValue', parseInt(e.target.value) || 0)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              min="1"
            />
          </div>
        </div>
      </div>

      {/* Bet Settings */}
      <div className="col-span-2 p-4 rounded-lg bg-gray-50">
        <h3 className="mb-3 text-lg font-semibold text-gray-900">Bet Settings</h3>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Min Lines</label>
              <input
                type="number"
                value={betBody.config.slot.settings.bets.minLines}
                onChange={(e) => updateSlotSettings('minLines', parseInt(e.target.value) || 0)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                min="1"
              />
            </div>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">Max Lines</label>
              <input
                type="number"
                value={betBody.config.slot.settings.bets.maxLines}
                onChange={(e) => updateSlotSettings('maxLines', parseInt(e.target.value) || 0)}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                min="1"
              />
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Coin Amount Multiplier</label>
            <input
              type="number"
              value={betBody.config.lineSets[0]?.coin_amount_multiplier || 25}
              onChange={(e) => updateLineSetMultiplier(parseInt(e.target.value) || 25)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              min="1"
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">Positions (через кому)</label>
            <input
              type="text"
              value={betBody.config.slot.settings.startPosition.join(', ')}
              onChange={(e) => updateStartPosition(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="0, 0, 0, 0, 0"
            />
            <p className="mt-1 text-xs text-gray-500">
              Поточний масив: [{betBody.config.slot.settings.startPosition.join(', ')}]
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetSettings;
